<template>
  <div>
    <div class="photoContainer">
      <img src="frontImages/introduction.jpg" class="topPhoto" />
    </div>

    <div class="separator"></div>

    <h1>{{ $t("introductionPage.h1") }}</h1>
    <p class="text first">{{ $t("introductionPage.text") }}</p>

    <div class="eng" v-if="this.$i18n.locale === 'en_US'">
      <h2 class="introductionTitle">{{ $t("introductionPage.title1") }}</h2>
      <p class="introductionText">{{ $t("introductionPage.subText1") }}</p>
      <p class="introductionText">{{ $t("introductionPage.subText2") }}</p>
      <p class="introductionText">{{ $t("introductionPage.subText3") }}</p>

      <h2 class="introductionTitle">{{ $t("introductionPage.title2") }}</h2>

      <h3 class="smallTitle">{{ $t("introductionPage.smallTitle1") }}</h3>
      <p class="introductionText">{{ $t("introductionPage.subText4") }}</p>

      <h3 class="smallTitle">{{ $t("introductionPage.smallTitle2") }}</h3>
      <p class="introductionText">{{ $t("introductionPage.subText5") }}</p>
    </div>

    <div class="separator"></div>

    <div class="subContainer1" v-if="this.$i18n.locale === 'zh_HK'">
      <p class="text">
        我們以為客戶提供最高質量的服務為一體，五星級的服務讓我們在客戶心目中建立了良好的信譽。我們熱忱的服務，只有您真正體驗了才知道。
      </p>
      <p class="text">
        我們以客戶為本，客戶的滿意是我們最大的動力。因此我們的竭誠服務涵蓋方方面的需求，從服務式辦公室的租賃到臨時通信地址的提供，從虛擬辦公地電話接線服務到提供經驗豐富的
        員工協助交易，提供證明文件以及銀行服務。
      </p>
      <p class="text">
        我們可以協助您建立香港，中國內陸或其他離岸公司，並為您提供周到的公司秘書服務。對於許多公司而言，在香港或海外註冊公司能為母國節省大量稅收支出。
      </p>
      <p class="text">
        選擇我們，我們必將為您省時省金，亦能助您的事業更上一層樓。我們更是您通向大中華市場及其他經濟體的門戶。
      </p>
      <p class="text">
        想要<a href="#/contactus">了解更多</a>，現在就和我們聯繫。
      </p>
    </div>

    <div class="separator"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
</script>

<style>
.photoContainer {
  width: 100%;
  position: relative;
  height: 35rem;
}

.topPhoto {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  object-fit: cover;
  object-position: 0% 25%;
}
</style>

<style scoped>
h1 {
  font-family: "Lato", sans-serif;
  font-weight: 500;
}

h2 {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 2em;
  text-align: left;
}

h3 {
  font-family: "Lato", sans-serif;
  font-weight: 300;
  text-align: left;
  font-size: 20px;
}

.text,
p {
  font-family: "Lato", sans-serif;
  color: #646464;
  text-align: left;
}

.subContainer1,
.subContainer2 {
  background-color: rgb(247, 247, 247);
  padding: 1rem;
}

.text.first {
  padding: 1rem;
}

.introductionTitle,
.introductionText {
  padding: 1rem;
}

.introductionText {
  padding-top: 0;
}

.introductionTitle {
  color: #099;
  padding-left: 1rem;
  font-weight: 500;
}

.smallTitle {
  padding: 1rem;
  color: #333333;
  font-weight: 400;
}

.text a {
  color: #099;
}
</style>
